export const locale = {
    lang: 'ar',
    data: {
        TRANSFORM_LIST: 'تحويل البطاقات إلى قوائم',
        SELECTION: 'اختيار',
        ACTIVITY: 'نشاط',
    }
};
